import { render, staticRenderFns } from "./SysUserAgentModal.vue?vue&type=template&id=4590b896&scoped=true&"
import script from "./SysUserAgentModal.vue?vue&type=script&lang=js&"
export * from "./SysUserAgentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4590b896",
  null
  
)

export default component.exports